import * as React from 'react';
import { Provider } from 'mobx-react';
import { ContentOrganizerAdminStore } from './stores';
import { IInstance } from '../../interfaces/IInstance';
import { ContentOrganizerAdmin } from './ContentOrganizerAdmin';
import { LoggingService } from '../../services/LoggingService';

export interface IProps {
  environment: "Development" | "Test" | "Production";
  tenant: string;
  token: string;
  instance: IInstance;
}

export class IAContentOrganizerAdmin extends React.Component<IProps> {

  private contentOrganizerAdminStore: ContentOrganizerAdminStore;

  constructor(props: IProps) {
    super(props);

    LoggingService.init(this.props.environment);

    this.contentOrganizerAdminStore = new ContentOrganizerAdminStore();
    this.contentOrganizerAdminStore.environment = props.environment;
    this.contentOrganizerAdminStore.token = props.token;
    this.contentOrganizerAdminStore.tenant = props.tenant;
    this.contentOrganizerAdminStore.instance = props.instance;
    this.contentOrganizerAdminStore.selectedInstance = undefined;
  }

  public componentWillReceiveProps(props: IProps) {
    if (props.instance != this.props.instance) {
      this.contentOrganizerAdminStore.instance = props.instance;
      this.contentOrganizerAdminStore.selectedInstance = undefined;
    }
  }

  render() {
    return (
      <Provider contentOrganizerAdminStore={this.contentOrganizerAdminStore}>
        <ContentOrganizerAdmin
          instance={this.props.instance}
        />
      </Provider>
    )
  }
}